import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-pp-file-directory-actions-modal',
  templateUrl: './pp-file-directory-actions-modal.component.html',
  styleUrls: ['./pp-file-directory-actions-modal.component.scss']
})
export class PPFileDirectoryModalComponent implements OnInit {

  selectAttachments: boolean = false;
  downloadAtt: boolean = false;
  dataLabel:string = "";
  labelSelectAll:string = "";
  newFolderForm: UntypedFormGroup;
  textFiltersMaxLength = 100;
  conditions = ['\\','/',':','*','?','\"','<','>','|'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PPFileDirectoryModalComponent>,
    private formBuilder: UntypedFormBuilder,
    public _toast : ToastService,
    private translate: TranslateService,
  ) { 
    this.newFolderForm = this.formBuilder.group({
      nameFolder: ['', [Validators.required, Validators.maxLength(256)]],
    })
  }

  ngOnInit(): void {
  }

  onCancel(){
    this.dialogRef.close(null);
  }

  onContinue(){
    if(this.conditions.some(el => this.newFolderForm.controls.nameFolder.value.includes(el))){
      //toast  
      this._toast.error(this.translate.instant('TOAST.ERROR.CREATE_FOLDER'))
    }else{
      //pass control
      this.dialogRef.close({
        nameFolder: this.newFolderForm.controls.nameFolder.value,
      });
    }
  }

  downloadAttachments(e){
    this.downloadAtt = e.checked;
  }

}
